import React from 'react';
import PropTypes from 'prop-types';
import Text from '../../../../ui/Text';
import styles from '../IntegrationsCards.module.scss';
import IntegrationStatus from './IntegrationStatus';

const ConnectedCard = ({
  connectionData, helpArticleHref, icon, lmsType, programId,
}) => (
  <div className={`${styles.cardWrapper} ${styles.fullWidth}`}>
    <Text className={`${styles.cardHeader} ${styles.headerWithIcon}`} size="lg">
      {lmsType}
      <img alt="" className={`${styles.integrationIcon}`} src={icon} />
    </Text>
    <Text size="sm">
      Automatically sync your TCI assignments and grades with {lmsType}.
      <a
        href={helpArticleHref}
        className="ml3"
        target="_blank"
        rel="noopener noreferrer"
      >
        Discover how to get started.
      </a>
    </Text>
    <div className="tw-flex tw-justify-between">

      <div className="mt20 tw-basis-1/2">
        {connectionData}
      </div>

      <IntegrationStatus lmsType={lmsType} programId={programId} />
    </div>
  </div>
);

ConnectedCard.propTypes = {
  connectionData: PropTypes.node.isRequired,
  helpArticleHref: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  lmsType: PropTypes.string.isRequired,
  programId: PropTypes.number.isRequired,
};

export default ConnectedCard;
